const STATE_KEY = "erpDeviceTrustState";
const VERIFIER_KEY = "erpDeviceTrustVerifier";
const EXPIRES_KEY = "erpDeviceTrustExpiresAt";
const RETURN_ROUTE_KEY = "erpDeviceTrustReturnRoute";

function base64Url(bytes) {
  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window
    .btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

function randomBase64Url(byteLength) {
  if (!window.crypto || !window.crypto.getRandomValues) {
    return Promise.reject(new Error("当前浏览器不支持安全随机数"));
  }
  const bytes = new Uint8Array(byteLength);
  window.crypto.getRandomValues(bytes);
  return Promise.resolve(base64Url(bytes));
}

function sha256Base64Url(value) {
  if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) {
    return Promise.reject(new Error("当前浏览器不支持安全设备授权"));
  }
  const data = new window.TextEncoder().encode(value);
  return window.crypto.subtle.digest("SHA-256", data).then((digest) => {
    return base64Url(new Uint8Array(digest));
  });
}

// 本地开发环境（webpack dev server）的来源规则：本机回环 / 局域网 192.168.* 网段，默认 dev 端口 8080。
// 与后端 DeviceTrustService 的 LOCAL_DEV_ORIGIN_PATTERN 保持一致。
const LOCAL_DEV_ORIGIN_RE = /^https?:\/\/(127\.0\.0\.1|localhost|192\.168\.\d{1,3}\.\d{1,3}):8080$/;

export function isUnifiedDeviceTrustClient() {
  const origin = window.location.origin;
  if (
    ["https://admin-test.xaoji.com", "https://localhost:8080"].includes(origin)
  ) {
    return true;
  }
  return LOCAL_DEV_ORIGIN_RE.test(origin);
}

export function createDeviceTrustRequest() {
  return Promise.all([randomBase64Url(32), randomBase64Url(64)]).then(
    ([state, verifier]) => {
      return sha256Base64Url(verifier).then((codeChallenge) => ({
        state,
        verifier,
        codeChallenge,
      }));
    },
  );
}

export function savePendingDeviceTrust(request, expiresAt, returnRoute) {
  sessionStorage.setItem(STATE_KEY, request.state);
  sessionStorage.setItem(VERIFIER_KEY, request.verifier);
  sessionStorage.setItem(EXPIRES_KEY, expiresAt);
  if (returnRoute) {
    sessionStorage.setItem(RETURN_ROUTE_KEY, JSON.stringify(returnRoute));
  }
}

export function getPendingDeviceTrust(state) {
  const storedState = sessionStorage.getItem(STATE_KEY);
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  const expiresAt = sessionStorage.getItem(EXPIRES_KEY);
  if (
    !state ||
    !storedState ||
    state !== storedState ||
    !verifier ||
    !expiresAt ||
    new Date(expiresAt).getTime() <= Date.now()
  ) {
    return null;
  }
  return {
    state,
    verifier,
    returnRoute: getStoredReturnRoute(),
  };
}

export function getStoredReturnRoute() {
  const value = sessionStorage.getItem(RETURN_ROUTE_KEY);
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

export function clearPendingDeviceTrust() {
  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(VERIFIER_KEY);
  sessionStorage.removeItem(EXPIRES_KEY);
  sessionStorage.removeItem(RETURN_ROUTE_KEY);
}

export function saveLoginSession(store, data) {
  sessionStorage.setItem("Authorization", data.sessionid);
  sessionStorage.setItem("identity", data.user_type || "");
  sessionStorage.setItem("city", data.city);
  sessionStorage.setItem("group", data.group);
  sessionStorage.setItem("user_other_type", data.other_type);
  if (data.house_selection_role != null && data.house_selection_role !== "") {
    sessionStorage.setItem(
      "house_selection_role",
      data.house_selection_role
    );
  } else {
    sessionStorage.removeItem("house_selection_role");
  }
  // 登录响应若带账号字段则一并缓存，供选房服务归属校验
  if (data.id || data.user_id) {
    sessionStorage.setItem("user_info_id", data.id || data.user_id);
  }
  if (data.name) {
    sessionStorage.setItem("user_info_name", data.name);
  }
  if (data.userName || data.username) {
    sessionStorage.setItem(
      "user_info_account",
      data.userName || data.username
    );
  }
  store.commit("SET_CITY", data.city);
}

export const deviceTrustStorageKeys = {
  state: STATE_KEY,
  verifier: VERIFIER_KEY,
  expiresAt: EXPIRES_KEY,
  returnRoute: RETURN_ROUTE_KEY,
};



// WEBPACK FOOTER //
// ./src/utils/deviceTrust.js